export const FETCH_INVENTORY_INIT = "FETCH_INVENTORY_INIT";
export const FETCH_INVENTORY_SUCCESS = FETCH_INVENTORY_INIT + "_SUCCESS";
export const FETCH_INVENTORY_FAIL = FETCH_INVENTORY_INIT + "_FAIL";

export const DELETE_VEHICLES_INIT = "DELETE_VEHICLES_INIT";
export const DELETE_VEHICLES_SUCCESS = DELETE_VEHICLES_INIT + "_SUCCESS";
export const DELETE_VEHICLES_FAIL = DELETE_VEHICLES_INIT + "_FAIL";

export const SEND_ITEM_INIT = "SEND_ITEM_INIT";

export const FETCH_COUNTRIES_INIT = "FETCH_COUNTRIES_INIT";
export const FETCH_COUNTRIES_SUCCESS = FETCH_COUNTRIES_INIT + "_SUCCESS";
export const FETCH_COUNTRIES_FAIL = FETCH_COUNTRIES_INIT + "_FAIL";

export const FETCH_SEGMENTS_INIT = "FETCH_SEGMENTS_INIT";
export const FETCH_SEGMENTS_SUCCESS = FETCH_SEGMENTS_INIT + "_SUCCESS";
export const FETCH_SEGMENTS_FAIL = FETCH_SEGMENTS_INIT + "_FAIL";

export const FETCH_CATEGORIES_INIT = "FETCH_CATEGORIES_INIT";
export const FETCH_CATEGORIES_SUCCESS = FETCH_CATEGORIES_INIT + "_SUCCESS";
export const FETCH_CATEGORIES_FAIL = FETCH_CATEGORIES_INIT + "_FAIL";

export const FETCH_CAPACITY_INIT = "FETCH_CAPACITY_INIT";
export const FETCH_CAPACITY_SUCCESS = FETCH_CAPACITY_INIT + "_SUCCESS";
export const FETCH_CAPACITY_FAIL = FETCH_CAPACITY_INIT + "_FAIL";

export const FETCH_SUBCAT_INIT = "FETCH_SUBCAT_INIT";
export const FETCH_SUBCAT_SUCCESS = FETCH_SUBCAT_INIT + "_SUCCESS";
export const FETCH_SUBCAT_FAIL = FETCH_SUBCAT_INIT + "_FAIL";

export const FETCH_BRANDS_INIT = "FETCH_BRANDS_INIT";
export const FETCH_BRANDS_SUCCESS = FETCH_BRANDS_INIT + "_SUCCESS";
export const FETCH_BRANDS_FAIL = FETCH_BRANDS_INIT + "_FAIL";

export const FETCH_REGION_INIT = "FETCH_REGION_INIT";
export const FETCH_REGION_SUCCESS = FETCH_REGION_INIT + "_SUCCESS";
export const FETCH_REGION_FAIL = FETCH_REGION_INIT + "_FAIL";

export const FETCH_INSURANCE_INIT = "FETCH_INSURANCE_INIT";
export const FETCH_INSURANCE_SUCCESS = FETCH_INSURANCE_INIT + "_SUCCESS";
export const FETCH_INSURANCE_FAIL = FETCH_INSURANCE_INIT + "_FAIL";

export const ADD_VEHICLE_INIT = "ADD_VEHICLE_INIT";
export const ADD_VEHICLE_SUCCESS = ADD_VEHICLE_INIT + "_SUCCESS";
export const ADD_VEHICLE_FAIL = ADD_VEHICLE_INIT + "_FAIL";

export const EDIT_VEHICLE_INIT = "EDIT_VEHICLE_INIT";
export const EDIT_VEHICLE_SUCCESS = EDIT_VEHICLE_INIT + "_SUCCESS";
export const EDIT_VEHICLE_FAIL = EDIT_VEHICLE_INIT + "_FAIL";

export const FETCH_VEHICLE_INIT = "FETCH_VEHICLE_INIT";
export const FETCH_VEHICLE_SUCCESS = FETCH_VEHICLE_INIT + "_SUCCESS";
export const FETCH_VEHICLE_FAIL = FETCH_VEHICLE_INIT + "_FAIL";

export const FETCH_LOCATION_INIT = "FETCH_LOCATION_INIT";
export const FETCH_LOCATION_SUCCESS = FETCH_LOCATION_INIT + "_SUCCESS";
export const FETCH_LOCATION_FAIL = FETCH_LOCATION_INIT + "_FAIL";

export const FETCH_USER_DRIVERS_INIT = "FETCH_USER_DRIVERS_INIT";
export const FETCH_USER_DRIVERS_SUCCESS = FETCH_USER_DRIVERS_INIT + "_SUCCESS";
export const FETCH_USER_DRIVERS_FAIL = FETCH_USER_DRIVERS_INIT + "_FAIL";

export const CREATE_VEHICLE_ACTION = "CREATE_VEHICLE_ACTION";
export const CREATE_VEHICLE_FAIL_ACTION = CREATE_VEHICLE_ACTION + "_ERROR";
export const CREATE_VEHICLE_SUCCESS_ACTION = CREATE_VEHICLE_ACTION + "_SUCCESS";

export function fetchvehicleInventory(value) {
  return {
    type: FETCH_INVENTORY_INIT,
    payload: value,
  };
}

export function deleteVehicles(value) {
  return {
    type: DELETE_VEHICLES_INIT,
    value: value,
  };
}

export function sendItem(value) {
  return {
    type: SEND_ITEM_INIT,
    value: value,
  };
}

export function fetchCountries() {
  return {
    type: FETCH_COUNTRIES_INIT,
  };
}

export function fetchSegments() {
  
  return {
    type: FETCH_SEGMENTS_INIT,
  };
}

export function fetchCat(value) {
  return {
    type: FETCH_CATEGORIES_INIT,
    value: value,
  };
}

export function fetchCapacity() {
  return {
    type: FETCH_CAPACITY_INIT,
  };
}

export function fetchSubCat(value) {
  return {
    type: FETCH_SUBCAT_INIT,
    value: value,
  };
}

export function fetchBrand() {
  return {
    type: FETCH_BRANDS_INIT,
  };
}

export function fetchRegion(value) {
  return {
    type: FETCH_REGION_INIT,
    value: value,
  };
}

export function fetchInsurance() {
  return {
    type: FETCH_INSURANCE_INIT,
  };
}

export function addVehicle(value) {
  return {
    type: ADD_VEHICLE_INIT,
    value: value,
  };
}

export function editVehicle(value) {
  return {
    type: EDIT_VEHICLE_INIT,
    value: value,
  };
}

export function fetchSpecificVehicle(value) {
  return {
    type: FETCH_VEHICLE_INIT,
    value: value,
  };
}

export function fetchLoctn(value) {
  return {
    type: FETCH_LOCATION_INIT,
    value: value,
  };
}
export function fetchDrivers(params) {
  return {
    type: FETCH_USER_DRIVERS_INIT,
    params:params
  };
}
